import React from "react";
import {IMarketsOdds} from "data/types/entities";
import styled from "@emotion/styled";
import {ChangeOddsType} from "data/enums";
import ArrowDownwardSharpIcon from "@mui/icons-material/ArrowDownwardSharp";
import ArrowUpwardSharpIcon from "@mui/icons-material/ArrowUpwardSharp";
import {css} from "@emotion/react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {IOddsController} from "views/components/odds/odds.controller";
import {Bindings} from "data/constants/bindings";

const Wrapper = styled.a<{historyOdds?: ChangeOddsType}>`
	max-width: 75px;
	width: 100%;
	border-radius: 2px;
	transition: all 0.3s ease;
	border: 1px solid var(--oddsBorderColor);
	background: var(--oddsBGColor);
	padding: 2px 0;
	display: flex;
	justify-content: center;
	--oddsBorderColor: #000;
	--oddsBGColor: rgba(0, 0, 0, 0.05);
	--oddsColor: #000;

	${({historyOdds}) =>
		historyOdds &&
		{
			[ChangeOddsType.DOWN]: css`
				--oddsBorderColor: #f00;
				--oddsBGColor: rgba(255, 0, 0, 0.05);
				--oddsColor: var(--oddsBorderColor);
			`,
			[ChangeOddsType.UP]: css`
				--oddsBorderColor: #3cb200;
				--oddsBGColor: rgba(24, 201, 113, 0.05);
				--oddsColor: #18c971;
			`,
			[ChangeOddsType.None]: css``,
		}[historyOdds]}
`;

const Stats = styled.div`
	position: relative;
	text-align: center;
	font-family: var(--fontFamilyBase);
	display: flex;
	flex-flow: row;
	justify-content: center;
	align-items: center;
	p {
		font-size: 12px;
		font-style: normal;
		font-weight: 700;
		line-height: 100%; /* 12px */
		text-transform: uppercase;
		transition: all 0.3s ease;

		&:last-of-type {
			font-weight: 500;
		}

		&:first-of-type {
			color: var(--oddsColor);
		}
	}

	svg {
		width: 12px;
		color: var(--oddsColor);
		transform: scale(0);
		animation: scaleUp 0.3s ease forwards;
		transform-origin: center;
	}
`;

interface IProps {
	odds: IMarketsOdds;
	link?: string;
}

export const Odds: React.FC<IProps> = observer(({odds, link}) => {
	const {changeState} = useViewController<IOddsController>(Bindings.OddsController, {
		odds,
	});

	return (
		<Wrapper href={link} target={"_blank"} historyOdds={changeState}>
			<Stats>
				{{
					[ChangeOddsType.DOWN]: <ArrowDownwardSharpIcon />,
					[ChangeOddsType.UP]: <ArrowUpwardSharpIcon />,
					[ChangeOddsType.None]: null,
				}[changeState] || null}
				<div>
					<p>{odds.handicap}</p>
					<p>{odds.value}</p>
				</div>
			</Stats>
		</Wrapper>
	);
});
